import React, { useEffect } from "react";
import { Container, Col, Row } from "reactstrap";
import { parse, stringify } from "qs";
import { omit } from "radash";
import {
  BADI_COLORS,
  BREAKPOINTS_PX,
  MatchMedia,
  Pagination,
  Text,
  Spacer,
} from "@badi/badi-components";
import styled from "styled-components";
import InboxRow from "./inbox-row";
import EmptyInbox from "./empty";
import Header from "./components/header/header";
import { CHATS_PER_PAGE } from "../constants";

import "./stylesExt.css";
import { getRelativePath } from "base/shared/Utils";

const FlexHorizontal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 60px;
`;

const Column = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const getQueryStringParametersWithout = (key) => {
  const parameters = omit(
    parse(window.location.search, { ignoreQueryPrefix: true }),
    [key],
  );
  return stringify(parameters);
};

const ChatsBrowser = ({
  connections,
  room: roomId,
  token,
  router,
  renderNavBar,
}) => {
  const filteredForConnections = roomId
    ? connections.filter(({ room }) => room.id == roomId)
    : connections;

  console.log("DEBUG: ", filteredForConnections);
  const hasConnections = filteredForConnections.length > 0;
  const total = filteredForConnections.length;
  const currentPage = 0; // should be whatever page we're currently on.
  const indexOfFirstChatInPage = 0; // these two attributes describe the range of connections being displayed on the current page
  const indexOfLastChatInPage = 30; // e.g on page 2 we'd being seeing connections 31 - 60, or whatever.
  const category = "default"; // should be whatever category has been selected.
  const roomTitle =
    roomId && hasConnections ? filteredForConnections[0].room.title : null; // should be the title of the currently filtered-for room.
  const totalPages = Math.ceil(total / CHATS_PER_PAGE);

  const handleChangePage = ({ page }) => {
    // const roomUrl = room ? `&room=${room}` : "";
    // router.push({
    //   pathname: "/inbox",
    //   search: `?category=${category}&page=${page}${roomUrl}&fromFilter=true`,
    // });
  };

  const handleChangeCategory = (category) => {};

  const handleOpenRoomFilter = () => {
    const pathname = `/rooms${window.location.search}`;
    router.push(pathname);
  };

  const handleCleanRoomFilter = () => {
    const queryStringParameters = getQueryStringParametersWithout("room");
    router.push(`/inbox/chats?${queryStringParameters}`);
  };

  return (
    <>
      <FlexHorizontal>
        <Column>{renderNavBar()}</Column>
        <Column>
          <Header
            defaultCategory={category}
            disabled={false}
            onCancelFilter={handleCleanRoomFilter}
            onChangeCategory={handleChangeCategory}
            onFilterClick={handleOpenRoomFilter}
            roomTitle={roomTitle}
            showFilterRoom={true}
          />
        </Column>
      </FlexHorizontal>
      <Row>
        <Col lg={{ offset: 1, size: 10 }} md={{ offset: 0, size: 12 }}>
          {hasConnections &&
            filteredForConnections.map((connection) => (
              <InboxRow
                connection={connection}
                key={connection.id}
                token={token}
              />
            ))}

          {!hasConnections && <EmptyInbox />}
        </Col>
      </Row>
      {hasConnections && (
        <Container className="Inbox--Pagination">
          <Row>
            <Col
              className="Inbox--Pagination-pages"
              md={{ offset: 3, order: 1, size: 6 }}
              xs={{ offset: 0, order: 2, size: 12 }}
            >
              <MatchMedia query={`(max-width: ${BREAKPOINTS_PX.sm})`}>
                {(match) => (
                  <Pagination
                    compact={match}
                    currentPage={currentPage}
                    onSelectPage={(page) => handleChangePage({ page })}
                    totalPages={totalPages}
                  />
                )}
              </MatchMedia>
            </Col>
            <MatchMedia query={`(min-width: ${BREAKPOINTS_PX.lg})`}>
              <Col
                className="Inbox--Pagination-overview"
                md={{ order: 2, size: 2 }}
                xs={{ offset: 0, order: 1, size: 12 }}
              >
                <Text body={3} color={BADI_COLORS.NEUTRAL.NEUTRAL_50}>
                  {`${indexOfFirstChatInPage}-${indexOfLastChatInPage} of ${total}`}
                </Text>
              </Col>
            </MatchMedia>
          </Row>
        </Container>
      )}
    </>
  );
};

export default ChatsBrowser;
